import React, {useEffect, useRef, useState,useMemo} from "react";
import {DeleteItemsApi} from "../../../../reduxToolkit/Commons/CommonsApi";
import {clearZoneDetailFatherAndChild} from "../../../../reduxToolkit/EmployeeZones/EmployeeZoneSlice";
import {useDispatch, useSelector} from "react-redux";
import {TABLES} from "../../../../Apis/Tables";
import TableFunction from "../../../../components/table/TableFunction";
import DropDownMenuProfile from "../../../../components/DropDown/DropDownMenuProfile";
import DropDownMenuItem from "../../../../components/DropDown/DropDownMenuItem";
import routes from "../../../../Routes/routes";
import {useNavigate} from "react-router-dom";
import CustomChip from "../../../../components/CustomChip";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../enums/statusColorEnum";
import {status} from "../../../../enums/statusEnum";
import ButtonSubAction from "../../../../components/buttons/ButtonSubAction";
import {permissionObj} from "../../../../Helpers/permission";
import {SEARCH_MODEL} from "../../../../components/table/Model/TableModel";
import {
    DetailsIconsOptions,
    PlusIconsOptions,
    UpdateIconsOptions
} from "../../../../components/buttons/IconButtons";
import {EMPTY_VALUES, errorMsg} from "../../../../Apis/functions";
import {SimpleSearch} from "../../../../reduxToolkit/Search/SearchApi";
import {VIEW_TYPE} from "../../../../enums/ViewType";
import RenderExpandedRow from "../SubComponents/RenderExpandedRow";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @JobTitle: Full Stack Developer
 *
 * @description
 * Custom hook `ZoneApp` for managing zones, including CRUD operations, pagination,
 * searching, and selection handling.
 *
 * @returns {Object} An object containing state and functions for zone management.
 */
export const ZoneApp = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [modalShow, setModalShow] = useState(false);
    const [deleteShow, setDeleteShow] = useState(false);
    const [childModalShow, setChildModalShow] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const contractorId = sessionStorage.getItem('contractorId');
    const supplierId = sessionStorage.getItem('providerId');
    const [search, setSearch] = useState(false);
    const [searchElement, setSearchElement] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [bodyForExport, setBodyForExport] = useState();
    const option = TABLES.ZONE;
    const elementRef = useRef(null);

    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    const [modified,setModified] = useState(false)
    const [selectedList, setSelectedList] = useState([]);
    const [isFatherZone, setIsFatherZone] = useState({});
    const [expandedRowId, setExpandedRowId] = useState(null);
    const [subZoneRefreshKey, setSubZoneRefreshKey] = useState(false);
    sessionStorage.setItem('zonesStack', JSON.stringify([]));

    /**
     * Forces the expanded row to re-fetch its detail, so a newly created sub zone shows up
     * without collapsing/expanding the row again.
     * The zone list is not reloaded here: a sub zone does not change the father zone rows,
     * so only the zone detail endpoint is called instead of the simple search.
     * @param {boolean} value - Modification flag sent by the create zone modal.
     */
    const handleSubZoneModified = (value) => {
        if (value) setSubZoneRefreshKey((prev) => !prev);
    };

    const handleRowExpand = (row) => {
        if (row?.zoneId !== expandedRowId) {
            setExpandedRowId(row?.zoneId);
        }
    };

    // Normalize results so every row exposes `id` (= zoneId), required by the table
    // for row keys, checkbox selection and deletion, regardless of the search source.
    const applySearchResults = (data) => {
        setSearchResults(
            data?.content
                ? {...data, content: data.content.map((e) => ({...e, id: e.zoneId}))}
                : data
        );
    };

    const renderOptionsMenu = (row,index) => {
        return (
            <>
                <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle} menuId={`menu-${row?.zoneId}`}>
                    <DropDownMenuItem
                        index={index}
                        handleClose={handleClose}
                        name={t('details')}
                        click={() => {
                            dispatch(clearZoneDetailFatherAndChild());
                            navigate(routes.zone.details + row?.zoneId);
                            sessionStorage.setItem('zonesStack', JSON.stringify([{ id: row?.zoneId, name: row?.name }]),);
                        }}
                        icon={<DetailsIconsOptions/>}
                    />
                </DropDownMenuProfile>
            </>
        )
    };

    const columns = useMemo(()=> [
        {
            field: 'zoneName',
            label: 'name',
            className: "w-40vw",
            classNameContainerTooltip: "w-40vw",
            render: (value,row) => {
                return {
                    text:  value,
                    subChip :
                        <>
                            {(DEV || permission?.includes(permissionObj?.WEB_ZONE_CREATE)) &&
                            <ButtonSubAction
                                id="btn_zc_add_sub_zone"
                                name="create_subzone"
                                Icon={PlusIconsOptions}
                                onClick={() => {
                                    setChildModalShow(true);
                                    setIsFatherZone({ id: row?.zoneId, name: value });
                                }}
                            />
                            }
                        </>
                }
            }
        },
        {
            field: 'statusId',
            label: 'status',
            render: (statusId) => {
                return (
                    <CustomChip
                        background={statusColor[statusId]}
                        fontColor={statusFontColor[statusId]}
                        borderColor={statusBorderColor[statusId]}
                        legend={t(status[statusId]) || EMPTY_VALUES.DEFAULT} variant={'large'}
                    />
                );
            }
        }
    ],[])

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            model: option,
            key: searchElement,
            view: VIEW_TYPE.GRID.viewType,
        });

        setBodyForExport(body);
        dispatch(SimpleSearch({ body })).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success === true) {
                    applySearchResults(data);
                }
            },
        );
    }

    const {t,handleCheckboxChange, handleDeleteAll,handleMenuToggle,
        handleClose,openMenu,
        pagination, page, rowsPerPage} = TableFunction({
        selectedList,
        setSelectedList,
        data: searchResults,
        labelRowsPerPage:'zone_per_page',
        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    useEffect(() => {
        if (elementRef.current) {
            const rect = elementRef.current.getBoundingClientRect();
            const distanceTop = rect.top + 0;
            elementRef.current.style.setProperty('--top-value', `${distanceTop}px`);
        }
    }, []);

    /**
     * Deletes selected zones.
     * @param {Array} deleteItem - The list of zone IDs to delete.
     */
    const deleteZone = (deleteItem) => {
        const tableName = option;
        const body = deleteItem;
        dispatch(DeleteItemsApi({ tableName, body })).then(({payload: {data: { success, code },},}) => {
                if(success){
                    setSelectedList([]);
                    setModified(true);
                }else errorMsg(code)
            },
        );
    };

    // Stable component reference so the table does not remount the expanded row
    // (and refetch) on every parent re-render, e.g. when toggling the options menu.
    // It only changes when a sub zone is created, to force the detail re-fetch.
    const renderExpandedRow = useMemo(
        () => (props) => <RenderExpandedRow {...props} refreshKey={subZoneRefreshKey}/>,
        [subZoneRefreshKey]
    );

    return {
        setModalShow, setDeleteShow, searchElement, setSearchElement, setSearchResults: applySearchResults, setBodyForExport,
        setSearch, simpleSearch, setSimpleSearch, contractorId, supplierId,
        handleDeleteAll, searchResults, modalShow, deleteShow, deleteZone,
        handleCheckboxChange, option,pagination,page,
        rowsPerPage,childModalShow,setChildModalShow,
        modified,
        setModified,
        handleSubZoneModified,
        columns,
        renderOptionsMenu,
        handleRowExpand,
        selectedList,
        setSelectedList,
        isFatherZone,
        t,
        DEV,
        permission,
        renderExpandedRow
    };
};
